import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c9d4cb3c")

_pushScopeId("data-v-c9d4cb3c")
const _hoisted_1 = {
  key: 0,
  class: "block export-pdf only-mobile"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "export-button-inner" }, [
  /*#__PURE__*/_createTextVNode(" Export PDF "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-save" })
], -1)
const _hoisted_3 = {
  key: 1,
  class: "export-pdf non-mobile"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Export PDF:", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_ctx.mobile)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Button, {
          disabled: _ctx.isDownloading,
          type: _ctx.ButtonType.Neutral,
          class: "export-button",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.downloadPdf()))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled", "type"])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Button, {
          disabled: _ctx.isDownloading,
          class: "export-button collapse",
          "icon-left": "save",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.downloadPdf()))
        }, null, 8, ["disabled"])
      ]))
})